<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>设备操作日志列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="搜索：">
                <el-input size="small" v-model="formInline.name" placeholder="设备名"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input size="small" v-model="formInline.nickname" placeholder="所属用户"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input size="small" v-model="formInline.imei" placeholder="IMEI"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column sortable prop="id" label="ID" show-overflow-tooltip></el-table-column>
            <el-table-column prop="name" label="设备名" show-overflow-tooltip></el-table-column>
            <el-table-column prop="nickname" label="所属用户" show-overflow-tooltip></el-table-column>
            <el-table-column prop="phone" label="电话" show-overflow-tooltip></el-table-column>
            <el-table-column prop="action" label="操作内容" show-overflow-tooltip></el-table-column>
            <el-table-column prop="imei" label="IMEI" show-overflow-tooltip></el-table-column>
            <el-table-column prop="create_time" label="操作时间" show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
</template>

<script>
    import Pagination from '../../components/Pagination'
    import {logs} from "../../api/userMG";

    export default {
        data() {
            return {
                loading: false, //是显示加载
                editFormVisible: false, //控制编辑页面显示与隐藏
                operatorVisible: false, //控制操作员页面显示与隐藏
                title: '添加/修改管理员',
                formInline: {
                    page: 1,
                    limit: 10,
                    pageSize: 10,
                    nickname: '',
                    imei: '',
                    phone: '',
                },
                userparm: [], //搜索权限
                listData: [], //用户数据
                listOperatorData: [], //操作员数据
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 10
                }
            }
        },
        // 注册组件
        components: {
            Pagination
        },
        /**
         * 创建完毕
         */
        created() {
            this.getdata(this.formInline)
        },

        /**
         * 里面的方法只有被调用才会执行
         */
        methods: {
            getdata(parameter) {
                this.loading = true
                logs(parameter).then(res => {
                    this.listData = res.items
                    this.loading = false
                    this.pageparm.currentPage = this.formInline.page
                    this.pageparm.pageSize = this.formInline.limit
                    this.pageparm.total = res.pageInfo.total
                })
            },
            // 分页插件事件
            callFather(parm) {
                this.formInline.page = parm.currentPage
                this.formInline.limit = parm.pageSize
                this.getdata(this.formInline)
            },
            // 搜索事件
            search() {
                this.getdata(this.formInline)
            },
        }
    }
</script>

<style scoped>
    .user-search {
        margin-top: 20px;
    }

    .userRole {
        width: 100%;
    }
</style>







// WEBPACK FOOTER //
// src/views/log/log.vue